import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Savingscustomdefaultcase } from "../shared/savingscustomdefaultcase.model"

@Injectable({
  providedIn: 'root'
})

export class SavingscustomdefaultcaseService {

  public selectedSavingsCustomDefaultCase: Savingscustomdefaultcase;
  public SavingscustomdefaultCaseList: Savingscustomdefaultcase[];

  savingscustomdefaultcase: Savingscustomdefaultcase;

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDDefaultCase(savingscustomdefaultcase:Savingscustomdefaultcase){

    savingscustomdefaultcase.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    savingscustomdefaultcase.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    savingscustomdefaultcase.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    savingscustomdefaultcase.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = savingscustomdefaultcase;
    
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/savingscustomdefaultcase/IUD', body, { headers: headers });

    }

  FetchInstallmentChangeById(savingscustomdefaultcase) {

    savingscustomdefaultcase.Id = + savingscustomdefaultcase.Id;
    savingscustomdefaultcase.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    savingscustomdefaultcase.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    savingscustomdefaultcase.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    savingscustomdefaultcase.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = savingscustomdefaultcase;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsCustomDefaultCase/Fetch', body, { headers: headers });
  }

  FetchInstallmentChangeList(){
 
   this.savingscustomdefaultcase = new Savingscustomdefaultcase();
   this.savingscustomdefaultcase.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
   this.savingscustomdefaultcase.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
   this.savingscustomdefaultcase.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
   this. savingscustomdefaultcase.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.savingscustomdefaultcase;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsCustomDefaultCase/FetchList', body, { headers: headers });
  }
}
